<template>
  <!-- Data presence is the only gate: this component knows nothing about customer_type, so
       mounting it in another panel stays a one-line add. -->
  <div class="v2026-topicsec" v-if="hasTopic">
    <span class="v2026-topicsec__label">หัวข้อสนทนา</span>
    <div class="v2026-topicsec__row">
      <!-- Read-only on purpose: no click, no hover, no removable affordance — the แท็ก chips below
           stay the only clickable chips in this column. -->
      <ActionChipV2026 class="v2026-topicsec__chip" :icon="icons.topic" :color="topicColor" :fill="topicFill">
        <span class="v2026-topicsec__chip-t">{{ displayLabel }}</span>
      </ActionChipV2026>
    </div>
  </div>
</template>

<script>
import ActionChipV2026 from './ActionChipV2026.vue'
import { displayChatTopic } from './chatTopicDisplay'
import { resolveTagChipFill } from './tagChipFill'

export default {
  name: 'chat-topic-section-v2026',
  components: {
    ActionChipV2026
  },
  props: {
    // The raw `chat_topic` row off the conversation. This component owns the null check.
    chatTopic: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      icons: {
        // The topic glyph the list card and the toolbar pill already use, NOT tag.svg (the
        // ActionChipV2026 default) — the glyph is one of the cues that this chip is not a tag.
        topic: require('@/assets/icons2026/topic.svg')
      }
    }
  },
  computed: {
    // computed, not a method: a method-driven label goes stale inside a slot on Vue 2.7.
    displayLabel () {
      return displayChatTopic(this.chatTopic)
    },
    hasTopic () {
      return !!this.displayLabel.trim()
    },
    // Same colour path as the list card: '' falls back to ActionChipV2026's teal, and null must
    // NEVER reach the chip's style binding.
    topicColor () {
      return (this.chatTopic && this.chatTopic.color) || ''
    },
    topicFill () {
      return resolveTagChipFill(this.topicColor)
    }
  }
}
</script>

<style scoped>
/* Local palette, like ChipRowV2026: the component stays portable to any panel. No margin here —
   the section rhythm comes from the panel's flex gap. */
.v2026-topicsec {
  --v2026-topicsec-text-secondary: #667085;

  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 0 16px;
}

/* Matches the แท็ก section label directly below. */
.v2026-topicsec__label {
  font-size: 13px;
  font-weight: 600;
  color: var(--v2026-topicsec-text-secondary);
}

.v2026-topicsec__row {
  display: flex;
  flex-wrap: wrap;
}

.v2026-topicsec__chip {
  max-width: 100%;
  align-items: flex-start;
  cursor: default;
}

/* The glyph is a flex item and would shrink before a long label does; pin it, and nudge it onto
   the first text line when the label wraps. */
::v-deep .v2026-topicsec__chip .v2026-action-chip-ico {
  flex: 0 0 auto;
  margin-top: 1px;
}

/* Wrap, never truncate. overflow-wrap: anywhere is required because Thai topic names often have
   no spaces at all, and word-break: break-word alone can still overflow. */
.v2026-topicsec__chip-t {
  min-width: 0;
  white-space: normal;
  word-break: break-word;
  overflow-wrap: anywhere;
}
</style>
